import { Stack } from "@mui/material";
import { useCallback } from "react";
import type {
  FieldConfiguration,
  NumberFormatterOptions,
} from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";
import { getDefaultFormatByAggregation } from "../utils/getNewDefaultFormatFormat";
import FormatSettings from "./FormatSettings";
import { canApplyFormat, getFormat, getLabel } from "./dimensionFormattingHelper";

interface Props {
  dimensions: DimensionField[];
  onUpdateConfig: (dimension: DimensionField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

export default function DimensionFormattingContainer({ dimensions, onUpdateConfig, readonlyMode }: Props) {
  const handleUpdateFormatter = useCallback(
    (field: DimensionField, formatter: NumberFormatterOptions | undefined) => {
      // Default format selected
      if (formatter === undefined) {
        formatter = getDefaultFormatByAggregation(field, field.config.aggregation);
      }
      onUpdateConfig(field, { format: formatter });
    },
    [onUpdateConfig]
  );

  return (
    <Stack sx={{ gap: 1 }}>
      {dimensions.filter(canApplyFormat).map((value) => {
        const label = getLabel(value);
        return (
          <FormatSettings
            key={value.config.guid}
            Label={label}
            format={getFormat(value)}
            onUpdateFormatter={(formatter) => handleUpdateFormatter(value, formatter)}
            readonlyMode={readonlyMode}
          />
        );
      })}
    </Stack>
  );
}
